import { isAfter, isBefore, isToday } from 'date-fns';
import { upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';

import {
  landlordBookingStageInformationText,
  landlordBookingStageInformationTextKeys,
  landlordBookingStageInformationTextKey,
} from '../../../../shared/helpers';
import { LandlordBooking, Stage } from '../../../../types/bookings';
import { reFormatDate } from '../../utils';
import { StyledText } from '../BookingStagesInformation.styles';

const BookingStageLandlordInformation = ({
  booking,
}: {
  booking: LandlordBooking;
}) => {
  const { t } = useTranslation(['bookingStageInformation']);

  if (booking.stage === Stage.Pending && booking.pricing.counter_offer > 0) {
    return (
      <StyledText>
        {upperFirst(
          t(
            'bookingStageInformation:landlordBookingStageCounterOfferInformation',
          ),
        )}
      </StyledText>
    );
  } else if (landlordBookingStageInformationTextKeys.includes(booking.stage)) {
    const stageValue =
      landlordBookingStageInformationText[
        booking.stage as landlordBookingStageInformationTextKey
      ];
    return (
      <StyledText
        isRejected={[
          Stage.Rejected,
          Stage.CreditNotVerified,
          Stage.CheckInKo,
        ].includes(booking.stage)}
      >
        {upperFirst(
          t(stageValue, {
            checkInDate: booking.period.start,
          }),
        )}
      </StyledText>
    );
  } else if (
    booking.stage === Stage.ContractSigned &&
    isBefore(new Date(), new Date(reFormatDate(booking.period.start))) &&
    booking.property.has_zappyrent_keys
  ) {
    return (
      <StyledText>
        {upperFirst(
          t(
            'bookingStageInformation:landlordBookingStageCheckInLessThanTodayAndKeyWithZrInformation',
            { checkInDate: booking.period.start },
          ),
        )}
      </StyledText>
    );
  } else if (
    booking.stage === Stage.ContractSigned &&
    isBefore(new Date(), new Date(reFormatDate(booking.period.start))) &&
    !booking.property.has_zappyrent_keys
  ) {
    return (
      <StyledText>
        {upperFirst(
          t(
            'bookingStageInformation:landlordBookingStageCheckInGreaterThanTodayAndKeyWithoutZrInformation',
            { checkInDate: booking.period.start },
          ),
        )}
      </StyledText>
    );
  } else if (
    booking.stage === Stage.CheckInOk &&
    isToday(new Date(reFormatDate(booking.period.start)))
  ) {
    return (
      <StyledText>
        {upperFirst(
          t(
            'bookingStageInformation:landlordBookingStageCheckInTodayInformation',
          ),
        )}
      </StyledText>
    );
  } else if (
    booking.stage === Stage.CheckInOk &&
    isAfter(new Date(), new Date(reFormatDate(booking.period.start))) &&
    !booking.property.has_zappyrent_keys
  ) {
    return (
      <StyledText>
        {upperFirst(
          t(
            'bookingStageInformation:landlordBookingStageCheckInLessThanTodayAndKeyWithoutZrInformation',
          ),
        )}
      </StyledText>
    );
  } else if (
    booking.stage === Stage.CheckInOk &&
    isAfter(new Date(), new Date(reFormatDate(booking.period.start))) &&
    booking.property.has_zappyrent_keys
  ) {
    return (
      <StyledText>
        {upperFirst(
          t(
            'bookingStageInformation:landlordBookingStageCheckInLessThanTodayAndKeyWithZrInformation',
          ),
        )}
      </StyledText>
    );
  } else {
    return null;
  }
};

export default BookingStageLandlordInformation;
